import React from "react";
import TrackingPage from "./TrackingPage";
import V2RouteShell from "../V2RouteShell";

function TrackingV2(props) {
  return (
    <V2RouteShell>
      <TrackingPage {...props} />
    </V2RouteShell>
  );
}

export default TrackingV2;
